import { useEffect, useState } from 'react';
import {
  getWorkflowRunLogs,
  getWorkflowRunSteps,
} from 'services/workflowService';
import { IWorkflowRunSteps } from 'interface/workflowInterface';
import CommonTable from 'components/common/TableCommon';
import { createHeadCellList } from './common';
import { useParams } from 'react-router-dom';
import { RootState } from 'redux-setup/store';
import { useAppSelector } from 'hooks/reduxHooks';
import { PopUpModal } from 'shared-components';
import './style.scss';
import { toast } from 'react-toastify';

export const WorkflowRunSteps = () => {
  const { id: workflowRunId } = useParams();
  const [workflowRunStepsData, setWorkflowRunStepsData] = useState<
    IWorkflowRunSteps[]
  >([]);
  const [selectedStepLogs, setSelectedStepLogs] = useState<string>('');
  const [isLogsModalOpen, setIsLogsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const organizationId = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const fetchWorkflowRunSteps = async () => {
    try {
      if (!organizationId || !workflowRunId) {
        return;
      }
      const response = await getWorkflowRunSteps({
        OrganizationID: organizationId,
        WorkflowRunID: workflowRunId,
      });
      const err = response.check();
      if (err) {
        toast.error('Failed to fetch workflow steps');
        return;
      }
      const steps = response.unwrap();
      if (steps.Result) {
        setWorkflowRunStepsData(steps.Result);
      }
    } catch (error) {
      console.error('Error fetching workflow steps:', error);
      toast.error('Failed to fetch workflow steps');
    }
  };

  const fetchWorkflowRunLogs = async (stepId: string) => {
    setIsLoading(true);
    try {
      const response = await getWorkflowRunLogs({
        OrganizationID: organizationId,
        WorkflowRunStepID: stepId,
      });
      const err = response.check();
      if (err) {
        toast.error('Failed to fetch logs');
        return;
      }
      const logs = response.unwrap();
      if (logs.Result) {
        setSelectedStepLogs(logs.Result);
        setIsLogsModalOpen(true);
      } else {
        setSelectedStepLogs('Logs are not available for this step.');
        setIsLogsModalOpen(true);
      }
    } catch (error) {
      console.error(`Error fetching logs for step ${stepId}:`, error);
      toast.error('Failed to fetch logs');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkflowRunSteps();
  }, []);

  return (
    <div>
      <h1 style={{ marginBottom: '20px' }}>Workflow Run Steps</h1>
      <CommonTable<IWorkflowRunSteps>
        headCellList={createHeadCellList(fetchWorkflowRunLogs)}
        data={workflowRunStepsData}
        isNextAPIDisabled={true}
      />
      <PopUpModal
        open={isLogsModalOpen}
        handleClose={() => setIsLogsModalOpen(false)}
        heading="Logs"
        buttons={[
          {
            buttonType: 'negative',
            buttonLabel: 'Close',
            buttonFunction: () => setIsLogsModalOpen(false),
          },
        ]}>
        <div className="popup-section">
          {isLoading ? (
            <p>Loading logs...</p>
          ) : (
            <pre className="logs-pre">{selectedStepLogs}</pre>
          )}
        </div>
      </PopUpModal>
    </div>
  );
};
